import { createAsyncThunk } from "@reduxjs/toolkit";
import { shuffle } from "lodash-es";

import { ThunkConfig } from "@/app/providers/StoreProvider";
import type { ApiError } from "@/shared/types";
import { handleError } from "@/shared/lib/helpers/utils";
import { Tarot } from "@/entities/Tarot";

export const fetchTarotImages = createAsyncThunk<Tarot[], string, ThunkConfig<ApiError>>(
  "fetchTarotImages",
  async (name, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
      const response = await extra.api.get<Tarot[]>(`/api/tarot_images?name=${name}`);

      return shuffle(response.data);
    } catch (err) {
      return rejectWithValue(handleError(err));
    }
  }
);
